import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import AuditLog from './AuditLog';
import { RouteContainer } from './Audit.style';
import { getAllRoutes } from '../utils/routes';
import type { IAuditLogActivity } from '../types/AuditLog';

const Root = (props: IAuditLogActivity) => {
    const { root } = getAllRoutes(props.baseRoute);
    const isDealAuditLog = useSelector(dealerSelectors.isDealAuditLog);
    return (
        isDealAuditLog && (
            <RouteContainer data-testid="activities-audit-log-container" className="activities-audit-log">
                <Route path={root} component={AuditLog} />
            </RouteContainer>
        )
    );
};

Root.displayName = 'AuditLog';

export default Root;
